module.exports = __webpack_public_path__ + "static/media/temperature-down.4234a5a2.svg";